module.exports = {
      id: "video-usage",
      viewBox: "0 0 54 37",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#video",
      toString: function () {
        return this.url;
      }
    }